import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useFetchValidationSchema } from 'app/utils/hooks';
import { getCreateIsniLink } from 'app/store/Profile/selectors';
import { CreateIsniData, UpdateIsniData } from 'types/isni.types';
import { createIsniEffect, updateIsniEffect } from 'app/store/Profile/effects';
import { IsniDialogComponent } from './IsniDialogComponent';
import { IsniDialogProps } from './types';

export const IsniDialog: React.FC<IsniDialogProps> = ({
  onClose,
  open,
  isni,
}) => {
  const dispatch = useAppDispatch();
  const createIsniLink = useAppSelector(getCreateIsniLink);
  const updateIsniLink = isni?._links?.updateIsni;

  const createIsni = async (data: CreateIsniData) => {
    const response = await dispatch(createIsniEffect(data)).unwrap();
    return response.status;
  };

  const updateIsni = async (data: UpdateIsniData) => {
    const response = await dispatch(
      updateIsniEffect({ data, isniNumber: isni?.isni })
    ).unwrap();
    return response.status;
  };

  const {
    validationSchema: createValidations,
    fetchingValidations: fetchingCreateValidations,
  } = useFetchValidationSchema({
    link: open && !isni ? createIsniLink : undefined,
  });
  const {
    validationSchema: updateValidations,
    fetchingValidations: fetchingUpdateValidations,
  } = useFetchValidationSchema({
    link: open && isni ? updateIsniLink : undefined,
  });

  return (
    <IsniDialogComponent
      open={open}
      onClose={onClose}
      createIsni={createIsni}
      updateIsni={updateIsni}
      createValidations={createValidations}
      updateValidations={updateValidations}
      fetchingValidations={
        fetchingCreateValidations || fetchingUpdateValidations
      }
      isni={isni}
    />
  );
};
